import { ILowInventoryNotificationsContent, IRemovePIIModalPayload } from '../../types/modals';
import { IDownloadCSVSuccessPayload } from '../../types/shell';

export const TOGGLE_ROCKET_MODAL = 'TOGGLE_ROCKET_MODAL';
export const TOGGLE_DOWNLOAD_SUCCESS_MODAL = 'TOGGLE_DOWNLOAD_SUCCESS_MODAL';
export const TOGGLE_LOW_INVENTORY_MODAL = 'TOGGLE_LOW_INVENTORY_MODAL';
export const TOGGLE_REMOVE_PII_MODAL = 'TOGGLE_REMOVE_PII_MODAL';
export const TOGGLE_ORG_CHANGED_MODAL = 'TOGGLE_ORG_CHANGED_MODAL';

export const toggleRocketModal = (payload?: any, metadata?: any) => ({
  type: TOGGLE_ROCKET_MODAL,
  payload,
  metadata,
});

export const toggleDownloadSuccessModal = (payload?: IDownloadCSVSuccessPayload) => ({
  type: TOGGLE_DOWNLOAD_SUCCESS_MODAL,
  payload,
});

export const toggleLowInventoryModal = (payload: boolean, metadata?: null | ILowInventoryNotificationsContent) => ({
  type: TOGGLE_LOW_INVENTORY_MODAL,
  payload,
  metadata,
});

export const toggleRemovePIIModal = (payload: boolean, metadata?: IRemovePIIModalPayload) => ({
  type: TOGGLE_REMOVE_PII_MODAL,
  payload,
  metadata,
});

export const setOrgChangedModalVisible = (payload: boolean) => ({
  type: TOGGLE_ORG_CHANGED_MODAL,
  payload,
});
